<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true">
      <el-form-item prop="userId">
        <el-select v-model="queryParams.userId" filterable placeholder="代理商" clearable>
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="productName">
        <el-input
          v-model="queryParams.productName"
          placeholder="请输入套餐名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="tableData" border id="out-table">
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="company" label="代理商" align="center">
            <template slot-scope="scope">
                【{{scope.row.username}}】{{scope.row.company}}
            </template>
        </el-table-column>
        <el-table-column prop="productName" label="套餐名称" align="center" min-width="160px">
          <template slot-scope="scope">
            【{{scope.row.productId}}】{{scope.row.productName}}
          </template>
        </el-table-column>
        <el-table-column label="简介" align="center" min-width="500px">
          <template slot-scope="scope">
            <el-descriptions :column="3" :colon="false"  >
             <template v-for="(item,index) in scope.row.extras" >
                <el-descriptions-item :key="index">{{item.operationName}}</el-descriptions-item>
                <el-descriptions-item label="运营商价格" :key="index">
                  <el-tag size="small">{{item.basePrice}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="加价" :key="index">
                  <el-tag size="small">{{item.extraPrice}}</el-tag>
                </el-descriptions-item>
             </template>
          </el-descriptions>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="160px">
            <template slot-scope="scope">
                <span>{{ parseTime(scope.row.createTime) }}</span>
            </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="[10, 20, 30, 40]"
        @size-change="handleSizeChange"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { userAgentList,productExtraPricePage } from "@/api/api.js"; //新建套餐代理商
export default {
  name: "productExtraPrice",
  data() {
    return {
      queryParams: {
          userId:undefined,
          productName:undefined
      },
      tableData: [],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
      agentList: [],
    }
  },
  components: {},
  computed: {},
  methods: {
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.initData();
    },
    // 获取列表
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      productExtraPricePage(params).then(res => {
        if (res.data.code == 200) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
        }else{
          this.$message.error(res.data.message)
        }
      });
    },
    // 搜索
    handleSearch() {
      this.page = 1,
      this.initData();
    },
    // 重置
    reset() {
      this.resetForm("queryForm");
      this.initData();
    },
    initAgentList(){
      userAgentList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
          this.agentList.forEach((value,index)=>{
            if(!value.company){
                value.company = '';
            }
          })
        }
      });
    },

  },
  created() {
    this.initAgentList();
    this.initData();
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
</style>